import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-20 md:py-28 bg-heritage-beige relative" data-id="element-111">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-112">
        <FadeIn data-id="element-113">
          <p className="font-script text-4xl md:text-5xl text-heritage-terracotta mb-8" data-id="element-114">
            "¿Qué pasará con mis recetas cuando yo ya no esté?"
          </p>

          <div className="space-y-6 text-lg md:text-xl text-heritage-coffee/90 leading-relaxed" data-id="element-115">
            <p data-id="element-116">
              Ese miedo es real porque la sazón no se hereda en los genes,{' '}
              <strong className="font-serif font-semibold text-heritage-terracotta" data-id="element-117">
                se hereda en el papel.
              </strong>
            </p>
            <p data-id="element-118">
              Si no documentas hoy la forma exacta en la que preparas ese guiso
              que tanto le gusta a tu familia, ese sabor morirá contigo.
            </p>
            <p className="font-serif text-2xl md:text-3xl mt-8 text-heritage-coffee" data-id="element-119">
              No dejes que el hilo de tu historia se corte en la cocina.
            </p>
          </div>

          <div className="mt-12 flex justify-center" data-id="element-120">
            <div className="w-24 h-[1px] bg-heritage-gold/50" data-id="element-121"></div>
          </div>
        </FadeIn>
      </div>
    </section>;
}